export default "__VITE_ASSET__df7bOR1p__"